<ul class="address-lines">
  <li *ngIf="address.fullName">
    <vdr-labeled-data [label]="'Address name'">{{ address.fullName }}</vdr-labeled-data>
  </li>
  <li *ngIf="address.streetLine1">
    <vdr-labeled-data [label]="'Street'" style="margin-bottom: 0">{{ address.streetLine1 }}</vdr-labeled-data>
  </li>
  <li *ngIf="address.streetLine2">{{ address.streetLine2 }}</li>
  <li *ngIf="address.city">
    <vdr-labeled-data [label]="'City'" style="margin-top: 6px">{{ address.city }}</vdr-labeled-data>
  </li>
  <li *ngIf="address.province">{{ address.province }}</li>
  <li *ngIf="address.postalCode">{{ address.postalCode }}</li>
  <li *ngIf="address.country">
    <vdr-labeled-data [label]="'Country'">
      <clr-icon shape="world" size="12"></clr-icon>
      {{ getCountryName() }}
    </vdr-labeled-data>
  </li>
  <li *ngIf="address.phoneNumber">
    <clr-icon shape="phone-handset" size="12"></clr-icon>
    {{ address.phoneNumber }}
  </li>
  <li *ngFor="let customField of getCustomFields()" class="custom-field">
    <ng-container *ngIf="!clickable(customField)">
      <vdr-labeled-data [label]="customField.key">
        {{ isDate(customField.value) ? (customField.value | date) : customField.value }}
      </vdr-labeled-data>
    </ng-container>
    <ng-container *ngIf="clickable(customField)">
      <vdr-labeled-data [label]="customField.key">
        <a [href]="getHref(customField)" target="_blank" class="link">
          {{ customField.value }}
        </a>
      </vdr-labeled-data>
    </ng-container>
  </li>
</ul>
